/**
 * Builds a user-facing string from an Apollo Client error (GraphQL, network, or generic).
 *
 * @param {Error | null | undefined} error - Typically an ApolloError from a mutation/query.
 * @param {{ fallback: string, joinAllGraphQLErrors?: boolean }} options
 * @param {string} options.fallback - Shown when nothing else is available.
 * @param {boolean} [options.joinAllGraphQLErrors=true] - If true, join all GraphQL error messages with a space; if false, use only the first.
 * @returns {string}
 */
export function getApolloErrorMessage(error, options) {
    const { fallback, joinAllGraphQLErrors = true } = options;
    if (!error) return fallback;

    const graphQLErrors = error.graphQLErrors || [];
    let fromGraphql = '';
    if (joinAllGraphQLErrors) {
        fromGraphql = graphQLErrors.map((e) => e && e.message).filter(Boolean).join(' ');
    } else {
        fromGraphql = (graphQLErrors[0] && graphQLErrors[0].message) || '';
    }

    const networkMessage = error.networkError && error.networkError.message;
    return fromGraphql || networkMessage || error.message || fallback;
}
